

























































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import CreateAgencyRoleRequest from '@/models/AgencyRoles/CreateAgencyRoleRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';

@Component({
    name: 'AgencyRoleCreate'
})
export default class extends GiganautVueDialog {

  public entity: any = new CreateAgencyRoleRequest();

  public permissionLevels = [
    { text: 'None', value: 0 },
    { text: 'View', value: 1 },
    { text: 'Manage', value: 2 },
  ];

  public permissionFields = [
    { field: 'permissionWorkers', label: 'Workers' },
    { field: 'permissionCompanies', label: 'Companies' },
    { field: 'permissionLocations', label: 'Locations' },
    { field: 'permissionContacts', label: 'Contacts' },
    { field: 'permissionBookings', label: 'Bookings' },
    { field: 'permissionJobs', label: 'Jobs' },
    { field: 'permissionOpportunities', label: 'Opportunities' },
    { field: 'permissionPayroll', label: 'Payroll' },
    { field: 'permissionSpecOuts', label: 'Spec Outs' },
    { field: 'permissionInvoices', label: 'Invoices' },
    { field: 'permissionTimesheets', label: 'Timesheets' },
    { field: 'permissionCampaigns', label: 'Campaigns' },
    { field: 'permissionMessaging', label: 'Messaging' },
    { field: 'permissionReports', label: 'Reports' },
    { field: 'permissionActivities', label: 'Activities' },
    { field: 'permissionCompliance', label: 'Compliance' },
    { field: 'permissionKpis', label: 'KPIs' },
    // Agency section
    { field: 'permissionSettingsAgencyProfile', label: 'Settings: Agency Profile' },
    { field: 'permissionSettingsBranches', label: 'Settings: Branches' },
    { field: 'permissionSettingsRateCards', label: 'Settings: Rate Cards' },
    { field: 'permissionSettingsUniforms', label: 'Settings: Uniforms' },
    { field: 'permissionSettingsReportingPeriods', label: 'Settings: Reporting Periods' },
    { field: 'permissionSettingsKpis', label: 'Settings: KPIs' },
    // Users & Permissions section
    { field: 'permissionSettingsUsers', label: 'Settings: Users' },
    { field: 'permissionSettingsGroups', label: 'Settings: Groups' },
    { field: 'permissionSettingsRoles', label: 'Settings: Roles' },
    // Communication section
    { field: 'permissionSettingsEmailTemplates', label: 'Settings: Email Templates' },
    { field: 'permissionSettingsConversationTopics', label: 'Settings: Conversation Topics' },
    { field: 'permissionSettingsBusinessHours', label: 'Settings: Business Hours' },
    // Categories section
    { field: 'permissionSettingsNoteCategories', label: 'Settings: Note Categories' },
    { field: 'permissionSettingsActivityCategories', label: 'Settings: Activity Categories' },
    // Work Types section
    { field: 'permissionSettingsIndustries', label: 'Settings: Industries' },
    { field: 'permissionSettingsLocationTypes', label: 'Settings: Location Types' },
    { field: 'permissionSettingsSkills', label: 'Settings: Skills' },
    { field: 'permissionSettingsQualifications', label: 'Settings: Qualifications' },
    { field: 'permissionSettingsPositions', label: 'Settings: Positions' },
    // Integrations section
    { field: 'permissionSettingsIntegrations', label: 'Settings: Integrations' },
    { field: 'permissionSettingsMobileApp', label: 'Settings: Mobile App' },
    // Sales / Pipeline section
    { field: 'permissionSettingsOpportunitySources', label: 'Settings: Opportunity Sources' },
    { field: 'permissionSettingsOpportunityLostReasons', label: 'Settings: Opportunity Lost Reasons' },
  ];

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = new CreateAgencyRoleRequest();
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    await AgencySettingsModule.createAgencyRole(this.entity)
    this.dialog = false;
  }
}
